module.exports = __webpack_public_path__ + "img/widgetabout-2.5e202528.jpg";